import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconRepairCounter = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    viewBox="0 0 13 14"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-repair-counter_svg__a)"
      d="M8.424 6.273c-.188 0-.375.024-.563.07L5.916 4.399c0-.187 0-.375.023-.562a3.36 3.36 0 0 1 2.532-2.719 3.343 3.343 0 0 1 1.594-.023c.257.07.351.398.164.586L8.61 3.297V5.03h1.758l1.617-1.593c.188-.188.516-.118.586.14a3.439 3.439 0 0 1-.023 1.617c-.234 1.008-.961 1.828-1.899 2.25L10.182 7a2.443 2.443 0 0 0-1.758-.727ZM9.666 7.54l2.742 2.695c.328.352.328.914 0 1.243l-1.242 1.242a.907.907 0 0 1-1.242 0L7.182 9.977c-.54-.54-.633-1.36-.328-2.016L4.369 5.477H2.916L.666 2.5l1.5-1.5 2.977 2.25v1.453L7.65 7.211a1.798 1.798 0 0 1 2.016.328Zm-3.68.656a2.57 2.57 0 0 0 .164 1.57l-2.789 2.79A1.595 1.595 0 0 1 2.236 13c-.398 0-.82-.14-1.125-.445a1.613 1.613 0 0 1 0-2.25l3.493-3.492 1.382 1.382Zm-3.82 3.867a.555.555 0 0 0 .563-.562.57.57 0 0 0-.563-.563.555.555 0 0 0-.562.563c0 .328.234.563.562.563Z"
    />
    <defs>
      <linearGradient
        id="icon-repair-counter_svg__a"
        x1={12.666}
        x2={1.708}
        y1={1.5}
        y2={13.455}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF968D" />
        <stop offset={0.18} stopColor="#E2645A" />
        <stop offset={0.73} stopColor="#D83832" />
        <stop offset={1} stopColor="#AD3529" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconRepairCounter;
